interface SignSearchFormProp {
    inputValue: string,
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    handleFormSubmit: (e: React.FormEvent<HTMLFormElement>) => void,
}

export default function SignSearchForm (
    {inputValue, handleInputChange, handleFormSubmit}: SignSearchFormProp
) {
    return <form className="d-flex" onSubmit={handleFormSubmit}>
        <input id="sign-search-input" 
            type="text"
            aria-label="Input signo a buscar"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Signo"/>
        <button id="sign-search-submit" type="submit" className="btn">🔍</button>
    </form>
}